import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import cookie from "js-cookie";
import server, { uploadServer } from "../../api/server";

const HeroSectionShow = ({ match }) => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const {
		params: { heroSectionId },
	} = match;

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		getValues,
		reset,
	} = useForm();

	const [pictureImg, setPictureImg] = useState(userPlaceholder);

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "اضافة فئة جديدة",
				breadcrumb: "الفئات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		try {
			const initialData = await server(cookie).get(
				`/pages/hero-section/sections/${heroSectionId}`
			);
			setPictureImg(
				`${process.env.REACT_APP_MAIN_URL}/${initialData?.data?.data?.section?.image}`
			);
			setValue("sectionTitle", initialData?.data?.data?.section?.sectionTitle);
			setValue("thumbnail", initialData?.data?.data?.section?.thumbnail);
			setValue("description", initialData?.data?.data?.section?.description);
			setValue("url", initialData?.data?.data?.section?.url);
			setValue("picturePath", initialData?.data?.data?.section?.image);
		} catch (error) {
			console.log(error);
		}
	};

	// handleMethods
	const submitHandler = async data => {
		setLoading(true);
		try {
			const imageResponse = async () => {
				if (data.pictureUrl.length <= 0) return data.picturePath;
				const dataForm = new FormData();
				dataForm.append("file", data.pictureUrl[0]);
				const imageData = await uploadServer(cookie).post("/upload", dataForm);
				return imageData?.data?.data?.file?.path;
			};
			const imageData = await imageResponse();
			const { picturePath, pictureUrl, ...finalData } = {
				...data,
				image: imageData,
			};

			const dataResponse = await server(cookie).put(
				`/pages/hero-section/sections/${heroSectionId}`,
				{
					section: finalData,
				}
			);
			history.push("/heroSection/index");
			reset();
			onStart();
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const handlePicture = () => {
		const tempValue = getValues("pictureUrl");
		if (tempValue.length < 1) return;
		const blobUrl = URL?.createObjectURL(tempValue?.[0]);
		setValue("picturePath", blobUrl);
		setPictureImg(blobUrl);
	};

	// watchers
	useEffect(() => {
		onStart();
	}, []);

	const renderError = name =>
		errors?.[name]?.type === "required" && (
			<p className="error-hint text-danger">هذا الحقل مطلوب</p>
		);
	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(submitHandler)}>
				<div className="row">
					<div className="col-md-8">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleAr">
										العنوان الرئيسي باللغة العربية
									</label>
									<input
										type="text"
										name="titleAr"
										id="titleAr"
										{...register("sectionTitle.ar", {
											required: true,
										})}
									/>
									{renderError(`sectionTitle.ar`)}
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleEn">
										العنوان الرئيسي بالغة الانجليزية
									</label>
									<input
										type="text"
										name="titleEn"
										id="titleEn"
										{...register("sectionTitle.en", {
											required: true,
										})}
									/>
									{renderError(`sectionTitle.en`)}
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="subTitleAr">
										العنوان الفرعي باللغة العربية
									</label>
									<input
										type="text"
										name="subTitleAr"
										id="subTitleAr"
										{...register("thumbnail.ar", {
											required: true,
										})}
									/>
									{renderError(`thumbnail.ar`)}
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="subTitleEn">
										العنوان الفرعي بالغة الانجليزية
									</label>
									<input
										type="text"
										name="subTitleEn"
										id="subTitleEn"
										{...register("thumbnail.en", {
											required: true,
										})}
									/>
									{renderError(`thumbnail.en`)}
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionAr">الوصف باللغة العربية</label>
									<textarea
										name="descriptionAr"
										id="descriptionAr"
										cols="30"
										rows="10"
										{...register("description.ar", {
											required: true,
										})}
									></textarea>
									{renderError(`description.ar`)}
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionEn">الوصف بالغة الانجليزية</label>
									<textarea
										name="descriptionEn"
										id="descriptionEn"
										cols="30"
										rows="10"
										{...register("description.en", {
											required: true,
										})}
									></textarea>
									{renderError(`description.en`)}
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-4">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="buttonLink">رابط الزر</label>
									<input
										type="text"
										name="buttonLink"
										id="buttonLink"
										{...register("url", {
											required: true,
										})}
									/>
									{renderError(`url`)}
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="picture">البانر</label>
									<input
										type="file"
										id="picture"
										{...register("pictureUrl", {
											onChange: () => handlePicture(),
										})}
									/>
									{renderError(`pictureUrl`)}

									<img src={pictureImg} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<input
							type="text"
							name=""
							id=""
							style={{ display: "none" }}
							{...register("picturePath")}
						/>
						{renderError(`picturePath`)}

						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default HeroSectionShow;
